var styleObject = {
  "checkboxGroup": {
    "&:not(:last-child)": {
      "marginBottom": "1.25rem"
    }
  },
  "checkboxGroup_ul": {
    "listStyle": "none"
  },
  "checkboxGroup_ul__checkbox": {
    "marginBottom": "1.25rem"
  },
  "checkbox": {
    "display": "block",
    "paddingLeft": "1.375rem",
    "position": "relative",
    "WebkitAppearance": "none"
  },
  "checkbox_input_type_checkbox": {
    "display": "block",
    "left": "0",
    "opacity": "0",
    "position": "absolute",
    "&:focus + label::before": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px"
    },
    "&:hover + label::before": {
      "backgroundColor": "#fff",
      "borderColor": "#006fcf"
    },
    "&:hover + label::after": {
      "color": "#fff"
    },
    "&:checked + label:hover::before": {
      "borderColor": "#006fcf"
    },
    "&:checked + label::before": {
      "backgroundColor": "#006fcf",
      "borderColor": "#006fcf"
    },
    "&:checked + label::after": {
      "color": "#fff",
      "visibility": "visible"
    },
    "&:disabled + label": {
      "color": "#97999b",
      "cursor": "not-allowed"
    },
    "&:disabled:hover + label": {
      "color": "#97999b",
      "cursor": "not-allowed"
    },
    "&:disabled + label::before": {
      "backgroundColor": "#f7f8f9",
      "borderColor": "#c8c9c7",
      "cursor": "not-allowed"
    },
    "&:disabled:hover + label::before": {
      "backgroundColor": "#f7f8f9",
      "borderColor": "#c8c9c7",
      "cursor": "not-allowed"
    },
    "&:disabled + label::after": {
      "color": "#fff"
    },
    "&:disabled:hover + label::after": {
      "color": "#fff"
    },
    "&:disabled:checked + label a": {
      "textDecoration": "none"
    },
    "&:disabled:hover:checked + label a": {
      "textDecoration": "none"
    },
    "&:disabled:checked + label::before": {
      "backgroundColor": "rgba(0, 0, 0, 0.25)"
    },
    "&:disabled:hover:checked + label::before": {
      "backgroundColor": "rgba(0, 0, 0, 0.25)"
    }
  },
  "checkbox_label": {
    "fontFamily": "\"Helvetica Neue\", Helvetica, sans-serif",
    "fontSize": "1rem",
    "fontWeight": "400",
    "lineHeight": "1.5rem",
    "cursor": "pointer",
    "display": "inline-block",
    "marginBottom": "0",
    "minHeight": "1.375rem",
    "paddingLeft": "0.625rem",
    "position": "relative",
    "textTransform": "inherit",
    "verticalAlign": "middle",
    "&::before": {
      "backgroundColor": "#fff",
      "border": "0.0625rem solid #c8c9c7",
      "borderRadius": "0.25rem",
      "content": "\"\"",
      "display": "inline-block",
      "height": "1.375rem",
      "left": "0",
      "marginLeft": "-1.375rem",
      "position": "absolute",
      "transition": "border 0.25S ease-out, background-color 0.25S ease-out",
      "width": "1.375rem"
    },
    "&::after": {
      "fontFamily": "\"dls-icons-2.25.0\"",
      "content": "\"\"",
      "lineHeight": "1.375rem",
      "WebkitFontSmoothing": "antialiased",
      "MozOsxFontSmoothing": "grayscale",
      "alignItems": "center",
      "display": "flex",
      "fontSize": "0.84375rem",
      "height": "1.375rem",
      "justifyContent": "center",
      "left": "0",
      "marginLeft": "-1.375rem",
      "position": "absolute",
      "top": "0",
      "width": "1.375rem",
      "visibility": "hidden"
    }
  },
  "checkbox_label_input": {
    "&:only-child": {
      "position": "static"
    }
  },
  "checkbox_input_aria_invalid_true____label": {
    "&::before": {
      "backgroundColor": "#fff",
      "borderColor": "#b42c01"
    }
  },
  "checkbox_input_aria_invalid_true____label_a": {
    "&::before": {
      "backgroundColor": "#fff",
      "borderColor": "#b42c01"
    },
    "textDecoration": "underline"
  },
  "checkbox_input_aria_invalid_true": {
    "&:checked + label": {
      "color": "#53565a"
    },
    "&:checked + label a": {
      "color": "#006fcf"
    },
    "&:checked + label a:not(:hover)": {
      "textDecoration": "none"
    },
    "&:not(:checked):hover + label::before": {
      "borderColor": "#b42c01"
    }
  },
  "checkbox_input_aria_checked_mixed____label": {
    "&::after": {
      "fontFamily": "\"dls-icons-2.25.0\"",
      "content": "\"\"",
      "lineHeight": "1",
      "WebkitFontSmoothing": "antialiased",
      "MozOsxFontSmoothing": "grayscale"
    }
  }
};

export default styleObject;
